define.alias("ember-math-helpers/helpers/pow", "settings/helpers/pow");